import { useNavigate } from 'react-router-dom';

export default function ArticlePreview() {
  const navigate = useNavigate();

  const scrollToTopAndNavigate = (path: string) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(path);
  };

  const mainArticles = [
    {
      tag: 'Beginner Guide',
      tagColor: 'bg-primary-100 text-primary-700',
      title: 'Sugargoo Spreadsheet Complete Guide 2026',
      desc: 'Everything you need to know about using Sugargoo Spreadsheet — from finding the best deals to understanding shipping options and maximizing your savings.',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20minimal%20desk%20workspace%20with%20laptop%20showing%20colorful%20spreadsheet%20data%20charts%2C%20ceramic%20coffee%20cup%20and%20small%20succulent%20plant%2C%20warm%20morning%20sunlight%20streaming%20through%20sheer%20curtains%2C%20soft%20beige%20cream%20and%20sage%20green%20tones%2C%20modern%20editorial%20photography%2C%20clean%20organized%20aesthetic&width=800&height=450&seq=art-main-a1&orientation=landscape',
      path: '/sugargoo-spreadsheet-guide',
    },
    {
      tag: 'Shipping',
      tagColor: 'bg-accent-100 text-accent-700',
      title: 'Sugargoo Shipping Cost & Options Explained',
      desc: 'Understand all Sugargoo shipping methods, compare costs and delivery times, and choose the most affordable option for your international orders.',
      image: 'https://readdy.ai/api/search-image?query=International%20parcel%20boxes%20wrapped%20in%20kraft%20paper%20stacked%20neatly%20on%20wooden%20surface%2C%20shipping%20labels%20and%20customs%20forms%20visible%2C%20soft%20natural%20window%20lighting%2C%20warm%20earthy%20tones%2C%20minimalist%20product%20photography%2C%20organized%20logistics%20aesthetic%20with%20clean%20composition&width=800&height=450&seq=art-main-a2&orientation=landscape',
      path: '/sugargoo-shipping-guide',
    },
    {
      tag: 'In-Depth Review',
      tagColor: 'bg-secondary-100 text-secondary-700',
      title: 'Sugargoo Review 2026: Honest Pros & Cons',
      desc: 'Comprehensive review covering the Sugargoo platform, warehouse service, quality control, shipping experience, customer support, and overall value.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20review%20concept%20with%20five%20star%20ratings%20displayed%20elegantly%20on%20tablet%20screen%20beside%20fashion%20accessories%2C%20soft%20natural%20daylight%20through%20windows%2C%20warm%20cream%20and%20terracotta%20palette%2C%20editorial%20commercial%20photography%2C%20trustworthy%20and%20professional%20aesthetic%20with%20organic%20textures&width=800&height=450&seq=art-main-a3&orientation=landscape',
      path: '/sugargoo-review',
    },
  ];

  const extendedArticles = [
    {
      tag: 'Safety',
      tagColor: 'bg-accent-100 text-accent-700',
      title: 'Is Sugargoo Legit? Complete Safety Review',
      desc: 'Honest analysis of Sugargoo legitimacy covering payment security, warehouse transparency, buyer protection, and real user experiences worldwide.',
      image: 'https://readdy.ai/api/search-image?query=Security%20shield%20icon%20concept%20with%20verification%20checkmark%20displayed%20on%20clean%20modern%20workspace%2C%20certificates%20and%20documents%20neatly%20arranged%2C%20warm%20natural%20daylight%2C%20soft%20cream%20and%20sage%20tones%2C%20trustworthy%20corporate%20aesthetic%2C%20professional%20editorial%20photography&width=800&height=450&seq=art-ext-b1&orientation=landscape',
      path: '/sugargoo-legit',
    },
    {
      tag: 'Money Saving',
      tagColor: 'bg-secondary-100 text-secondary-700',
      title: 'Sugargoo Coupon Codes & Discount Guide',
      desc: 'Discover where to find active Sugargoo coupons, seasonal promotions, new user benefits, and expert strategies for stacking multiple savings on every order.',
      image: 'https://readdy.ai/api/search-image?query=Colorful%20discount%20tags%20and%20gift%20vouchers%20artistically%20arranged%20on%20soft%20cream%20linen%20surface%2C%20golden%20ribbon%20accents%20scattered%20elegantly%2C%20warm%20natural%20side%20lighting%2C%20luxury%20minimalist%20aesthetic%2C%20editorial%20flat%20lay%20photography%20with%20soft%20shadows%20and%20sophisticated%20composition&width=800&height=450&seq=art-ext-b2&orientation=landscape',
      path: '/sugargoo-coupon',
    },
    {
      tag: 'Warehouse',
      tagColor: 'bg-primary-100 text-primary-700',
      title: 'Sugargoo Warehouse: Storage & QC Explained',
      desc: 'Everything about Sugargoo warehouse operations: quality control photos, free storage periods, packaging optimization, and value-added services for smarter shipping.',
      image: 'https://readdy.ai/api/search-image?query=Clean%20organized%20warehouse%20interior%20with%20neatly%20labeled%20storage%20shelves%20and%20cardboard%20boxes%2C%20warm%20industrial%20lighting%2C%20modern%20logistics%20facility%2C%20professional%20documentary%20style%20photography%2C%20soft%20natural%20tones%20with%20warm%20accents%2C%20spacious%20and%20efficient%20atmosphere&width=800&height=450&seq=art-ext-b3&orientation=landscape',
      path: '/sugargoo-warehouse',
    },
    {
      tag: 'Shopping Guide',
      tagColor: 'bg-accent-100 text-accent-700',
      title: 'Sugargoo Shopping Guide: Beginner to Pro',
      desc: 'Step-by-step shopping guide covering product discovery, budget planning, sizing tips, haul building strategies, and everything first-time shoppers need to know.',
      image: 'https://readdy.ai/api/search-image?query=Fashion%20items%20sneakers%20hoodie%20and%20accessories%20displayed%20beautifully%20on%20warm%20wooden%20table%2C%20smartphone%20showing%20shopping%20interface%20beside%20products%2C%20natural%20window%20light%2C%20modern%20lifestyle%20photography%2C%20cream%20sage%20and%20terracotta%20tones%2C%20aspirational%20editorial%20aesthetic&width=800&height=450&seq=art-ext-b4&orientation=landscape',
      path: '/sugargoo-shopping-guide',
    },
    {
      tag: 'Comparison',
      tagColor: 'bg-secondary-100 text-secondary-700',
      title: 'Best Sugargoo Finds By Category 2026',
      desc: 'Curated selection of the most popular Sugargoo products across shoes, clothing, accessories, and more — updated regularly with new discoveries and community favorites.',
      image: 'https://readdy.ai/api/search-image?query=Diverse%20fashion%20collection%20displayed%20in%20organized%20grid%20on%20warm%20neutral%20background%2C%20sneakers%20handbags%20hoodies%20and%20accessories%20arranged%20artistically%2C%20soft%20diffused%20lighting%20from%20above%2C%20modern%20ecommerce%20catalog%20style%2C%20clean%20minimalist%20aesthetic%2C%20warm%20cream%20and%20beige%20tones&width=800&height=450&seq=art-ext-b5&orientation=landscape',
      path: '/sugargoo-spreadsheet-guide',
    },
    {
      tag: 'Tips',
      tagColor: 'bg-primary-100 text-primary-700',
      title: 'How To Use Sugargoo Spreadsheet Like A Pro',
      desc: 'Advanced strategies for filtering, sorting, and cross-referencing spreadsheet data to find the absolute best deals and hidden gems across all product categories.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20hands%20typing%20on%20laptop%20keyboard%20with%20spreadsheet%20software%20visible%20on%20screen%2C%20coffee%20and%20notebook%20beside%2C%20focused%20work%20atmosphere%2C%20warm%20natural%20window%20lighting%2C%20modern%20coworking%20aesthetic%2C%20soft%20beige%20and%20sage%20tones%2C%20editorial%20photography&width=800&height=450&seq=art-ext-b6&orientation=landscape',
      path: '/sugargoo-spreadsheet-guide',
    },
    {
      tag: 'Alternatives',
      tagColor: 'bg-accent-100 text-accent-700',
      title: 'Sugargoo Alternatives: Comparison Guide',
      desc: 'Honest comparison of Sugargoo against other popular shopping agents — pricing, features, shipping options, and which platform suits different shopping styles best.',
      image: 'https://readdy.ai/api/search-image?query=Comparison%20concept%20with%20two%20tablets%20side%20by%20side%20on%20clean%20white%20desk%20showing%20different%20interfaces%2C%20small%20potted%20plant%20in%20background%2C%20natural%20daylight%2C%20modern%20tech%20aesthetic%2C%20soft%20cream%20tones%2C%20professional%20editorial%20photography%20with%20balanced%20composition&width=800&height=450&seq=art-ext-b7&orientation=landscape',
      path: '/sugargoo-review',
    },
    {
      tag: 'Budget',
      tagColor: 'bg-secondary-100 text-secondary-700',
      title: 'Budget Sugargoo Haul Tips: Maximize Value',
      desc: 'How to build an impressive Sugargoo haul on a tight budget — cheap shipping strategies, best value categories, and money-saving warehouse tricks.',
      image: 'https://readdy.ai/api/search-image?query=Coins%20and%20shopping%20items%20arranged%20creatively%20on%20warm%20wooden%20surface%2C%20budget%20planning%20concept%2C%20soft%20natural%20light%20from%20side%20window%2C%20cozy%20home%20atmosphere%2C%20warm%20cream%20and%20earthy%20tones%2C%20editorial%20still%20life%20photography%20with%20thoughtful%20composition&width=800&height=450&seq=art-ext-b8&orientation=landscape',
      path: '/sugargoo-coupon',
    },
    {
      tag: 'Trending',
      tagColor: 'bg-primary-100 text-primary-700',
      title: 'Trending Sugargoo Finds: Most Popular Products',
      desc: 'Discover what international shoppers are buying right now — trending sneakers, viral clothing pieces, and accessories that the Sugargoo community cannot stop talking about.',
      image: 'https://readdy.ai/api/search-image?query=Trending%20fashion%20items%20with%20upward%20arrow%20graphics%20concept%2C%20sneakers%20and%20accessories%20displayed%20on%20modern%20marble%20surface%2C%20soft%20editorial%20lighting%2C%20warm%20cream%20and%20terracotta%20palette%2C%20contemporary%20lifestyle%20photography%2C%20aspirational%20yet%20approachable%20composition&width=800&height=450&seq=art-ext-b9&orientation=landscape',
      path: '/sugargoo-spreadsheet-guide',
    },
  ];

  return (
    <section className="w-full py-14 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
            Sugargoo Spreadsheet Guides & Resources
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Expert-written guides to help you master Sugargoo shopping — from beginner tips to advanced strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-10">
          {mainArticles.map((article, idx) => (
            <article
              key={`main-${idx}`}
              className="bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-primary-200 transition-all duration-300 group cursor-pointer"
              onClick={() => scrollToTopAndNavigate(article.path)}
            >
              <div className="h-44 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className={`inline-block px-3 py-1 rounded-full text-xs font-semibold mb-3 ${article.tagColor}`}>
                  {article.tag}
                </span>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.desc}
                </p>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 text-sm text-foreground-500 mb-1">
            <span className="w-8 h-px bg-background-300"></span>
            More Expert Articles
            <span className="w-8 h-px bg-background-300"></span>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mb-10">
          {extendedArticles.map((article, idx) => (
            <article
              key={`ext-${idx}`}
              className="bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-primary-200 transition-all duration-300 group cursor-pointer"
              onClick={() => scrollToTopAndNavigate(article.path)}
            >
              <div className="h-40 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className={`inline-block px-3 py-1 rounded-full text-xs font-semibold mb-3 ${article.tagColor}`}>
                  {article.tag}
                </span>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {article.desc}
                </p>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center">
          <a
            href="/sugargoo-spreadsheet-guide"
            onClick={(e) => { e.preventDefault(); scrollToTopAndNavigate('/sugargoo-spreadsheet-guide'); }}
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Read All Guides
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}